module.exports = __webpack_public_path__ + "img/2BB.1.653f0436.jpg";